export const Whatuni = {
    projectName: "Whatuni",
    affiliateId: 220703
}

export const PGS = {
    projectName: "PGS",
    affiliateId: 607022
}